import { render, staticRenderFns } from "./JgpProcOperator.vue?vue&type=template&id=71b2597b&"
import script from "./JgpProcOperator.vue?vue&type=script&lang=js&"
export * from "./JgpProcOperator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports